<template>
  <v-app id="inspire">
    <v-navigation-drawer
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
    >
      <v-list-item style="padding: 15px">
        <v-list-item-avatar>
          <v-img
            src="https://cdn2.iconfinder.com/data/icons/ios-7-icons/50/user_male2-512.png"
          ></v-img>
          <!-- <v-icon>mdi-account</v-icon> -->
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>{{ nameSurname }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>
      <v-list dense>
        <template v-for="item in items">
          <div v-bind:key="item.text" v-if="isVisibleMenu(item.roles)">
            <v-row v-if="item.heading" :key="item.heading" align="center">
              <v-col cols="6">
                <v-subheader v-if="item.heading">{{
                  item.heading
                }}</v-subheader>
              </v-col>
              <v-col cols="6" class="text-center">
                <a href="#!" class="body-2 black--text">EDIT</a>
              </v-col>
            </v-row>
            <v-list-group
              v-else-if="item.children"
              :key="item.text"
              :color="'#4d48f9'"
              v-model="item.model"
              :prepend-icon="item.model ? item.icon : item['icon-alt']"
              append-icon
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item
                v-for="(child, i) in item.children"
                :key="i"
                :to="child.to"
                :style="isVisibleMenu(child.roles) ? '' : 'display:none'"
                exact
                link
              >
                <v-list-item-action v-if="child.icon">
                  <v-icon>{{ child.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title style="white-space: unset">{{
                    child.text
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
            <v-list-item
              v-else
              :key="item.text"
              :to="item.to"
              @click="listItemModel"
              link
              exact
            >
              <v-list-item-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </div>
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
      color="blue darken-3"
      dark
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-toolbar-title style="width: 300px" class="ml-0 pl-4">
        <span class="hidden-sm-and-down">
          <img src="@/assets/frink_beyaz_logo.png" style="width: 100px" />
        </span>
      </v-toolbar-title>
      <v-spacer />
      <v-menu top offset-y>
        <template v-slot:activator="{ on }">
          <!-- <v-btn style="background-color:transparent;color:white;" dark v-on="on"  @click="logOut()">Çıkış Yap</v-btn> -->
          <h4
            dark
            v-on="on"
            style="color: white; cursor: pointer"
            @click.stop="dialog = true"
          >
            Çıkış Yap
          </h4>
        </template>
        <!-- <v-list>
          <v-list-item v-for="(item, index) in userMenu" :key="index" @click="logOut()">
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list>-->
      </v-menu>
    </v-app-bar>
    <v-dialog v-model="dialog" max-width="390">
      <v-card>
        <v-card-title class="headline">Uyarı</v-card-title>

        <v-card-text>Çıkış yapmak istediğinize emin misiniz?</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            style="color: #1565c0 !important"
            text
            @click="dialog = false"
            >İptal</v-btn
          >

          <v-btn
            color="green darken-1"
            style="color: #1565c0 !important"
            text
            @click="logOut()"
            >Devam</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <router-view style="padding: 25px"></router-view>
  </v-app>
</template>

<script>
export default {
  name: "Dashboard",

  components: {},
  methods: {
    logOut() {
      localStorage.removeItem("frinkUserToken");
      localStorage.removeItem("nameSurname");
      localStorage.removeItem("userRoles");
      localStorage.removeItem("email");
      localStorage.removeItem("refreshToken");
      this.dialog = false;
      window.location.href = "/";
    },
    listItemModel() {
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].children != null) this.items[i].model = false;
      }
    },
    isVisibleMenu(requiredRole) {
      let isVisible = false;

      requiredRole.forEach((element) => {
        if (this.userRoles.find((x) => x == element) != undefined) {
          isVisible = true;
          return true;
        }
      });

      return isVisible;
    },
    base64UrlDecode(base64Url) {
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const buffer = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
      return buffer;
    },
  },

  data: () => ({
    userRoles: [],
    dialog: false,
    items: [
      {
        icon: "mdi-home",
        text: "Anasayfa",
        to: "/dashboard",
        roles: ["PanelUser", "PanelVenueUser", "PanelReportUser"],
      },
      {
        icon: "mdi-chevron-up",
        "icon-alt": "mdi-chevron-down",
        text: "Üye İş Yeri Yönetimi",
        model: false,
        roles: ["PanelUser", "PanelVenueUser"],
        children: [
          {
            icon: "mdi-store",
            text: "Firma Yönetimi",
            to: "/dashboard/companies",
            roles: ["PanelUser"],
          },
          {
            icon: "mdi-store-24-hour",
            text: "Mağaza Yönetimi",
            to: "/dashboard/venues",
            roles: ["PanelUser", "PanelVenueUser"],
          },
          {
            icon: "mdi-account",
            text: "Panel Kullanıcıları",
            to: "/dashboard/users/panelUsers",
            roles: ["PanelUser", "PanelVenueUser"],
          },
          {
            icon: "mdi-account",
            text: "MerchantApp Kullanıcıları",
            to: "/dashboard/users/readerAppUsers",
            roles: ["PanelUser", "PanelVenueUser"],
          },
          {
            icon: "mdi-image-check",
            text: "MerchantApp Welcome Ekranı",
            to: "/dashboard/merchant-onboardings",
            roles: ["PanelUser"],
          },
        ],
      },
      {
        icon: "mdi-chevron-up",
        "icon-alt": "mdi-chevron-down",
        text: "Üye Yönetimi",
        model: false,
        roles: ["PanelUser"],
        children: [
          {
            icon: "mdi-store",
            text: "Son Kullanıcı Yönetimi",
            to: "/dashboard/endUserManagements",
            roles: ["PanelUser"],
          },
          {
            icon: "mdi-store",
            text: "UserApp Kampanya Yönetimi",
            to: "/dashboard/campaigns",
            roles: ["PanelUser"],
          },
          {
            icon: "mdi-store",
            text: "MerchantApp Kampanya Yönetimi",
            to: "/dashboard/merchant-campaigns",
            roles: ["PanelUser"],
          },
          {
            icon: "mdi-store",
            text: "Yardım Menüsü Yönetimi",
            to: "/dashboard/helpMenuContents",
            roles: ["PanelUser"],
          },
          {
            icon: "mdi-image-check",
            text: "Banner Yönetimi ",
            to: "/dashboard/banner/list",
            roles: ["PanelUser"],
          },
          {
            icon: "mdi-cellphone-lock",
            text: "Çoklu Cihaz Yönetimi",
            to: "/dashboard/users/LockedUsersManagement",
            roles: ["PanelUser"],
          },
        ],
      },
      {
        icon: "mdi-chevron-up",
        "icon-alt": "mdi-chevron-down",
        text: "Ürün Yönetimi",
        model: false,
        roles: ["PanelUser"],
        children: [
          // {
          //   icon: "mdi-account",
          //   text: "Süt Tipleri",
          //   to: "/dashboard/productCategories/milkTypes"
          // },
          // {
          //   icon: "mdi-account",
          //   text: "Kahve Boyutları",
          //   to: "/dashboard/productCategories/coffeeSizes"
          // }
          // ,
          {
            icon: "mdi-store",
            text: "Ödeme Planı Yönetimi",
            to: "/dashboard/subscriptionPlans",
            roles: ["PanelUser"],
          },
          {
            icon: "mdi-timer",
            text: "Sipariş Verme Süreleri",
            to: "/dashboard/productCategories/timePeriods",
            roles: ["PanelUser"],
          },
          {
            icon: "mdi-developer-board",
            text: "OnBoarding Ekranları",
            to: "/dashboard/onBoardings",
            roles: ["PanelUser"],
          },
        ],
      },
      {
        icon: "mdi-chevron-up",
        "icon-alt": "mdi-chevron-down",
        text: "Raporlar",
        model: false,
        roles: ["PanelUser", "PanelVenueUser", "PanelReportUser"],
        children: [
          {
            icon: "mdi-keyboard",
            text: "Grafikler",
            to: "/dashboard/reports/graphics",
            roles: ["PanelUser"],
          },
          {
            icon: "mdi-keyboard",
            text: "Satış Raporları",
            to: "/dashboard/reports/orders",
            roles: ["PanelUser", "PanelVenueUser", "PanelReportUser"],
          },
          {
            icon: "mdi-keyboard",
            text: "Mağaza Satış Raporları",
            to: "/dashboard/reports/venues",
            roles: ["PanelUser", "PanelVenueUser", "PanelReportUser"],
          },
          {
            icon: "mdi-storefront-edit-outline",
            text: "Mağaza Muhasebe Raporu",
            to: "/dashboard/reports/store-accounting",
            roles: ["PanelUser", "PanelVenueUser"],
          },
          {
            icon: "mdi-receipt-text",
            text: "Aylık Fatura Özeti",
            to: "/dashboard/reports/store-invoice-summary",
            roles: ["PanelUser", "PanelVenueUser"],
          },
          {
            icon: "mdi-receipt-text-clock",
            text: "Aylık Fatura Detay",
            to: "/dashboard/reports/store-invoice-detail",
            roles: ["PanelUser", "PanelVenueUser"],
          },
          {
            icon: "mdi-account-group",
            text: "Kullanıcılar Listesi",
            to: "/dashboard/reports/report-users",
            roles: ["PanelUser"],
          },
          {
            icon: "mdi-file-account",
            text: "Kullanıcı Raporları",
            to: "/dashboard/reports/report-users-report",
            roles: ["PanelUser"],
          },
          {
            icon: "mdi-sale",
            text: "Kullanıcı Kampanya Raporları",
            to: "/dashboard/reports/report-campaign",
            roles: ["PanelUser"],
          },
          {
            icon: "mdi-coffee-outline",
            text: "Ürün Raporları",
            to: "/dashboard/reports/report-products",
            roles: ["PanelUser"],
          },
          {
            icon: "mdi-cart-outline",
            text: "Alışveriş Raporları",
            to: "/dashboard/reports/report-shopping",
            roles: ["PanelUser"],
          },
          {
            icon: "mdi-store-outline",
            text: "Mağaza Raporları",
            to: "/dashboard/reports/report-store",
            roles: ["PanelUser"],
          },
          {
            icon: "mdi-storefront-check",
            text: "Mağaza Puanları Raporları",
            to: "/dashboard/reports/report-store-points",
            roles: ["PanelUser"],
          },
          {
            icon: "mdi-map-marker",
            text: "Frink Öneri Noktaları Raporları",
            to: "/dashboard/reports/report-frink-recommend",
            roles: ["PanelUser"],
          },
          {
            icon: "mdi-share-variant",
            text: "Arkadaşına Öner Raporları",
            to: "/dashboard/reports/report-suggest-friend",
            roles: ["PanelUser"],
          },
          {
            icon: "mdi-currency-usd",
            text: "Aylık Satış Raporları",
            to: "/dashboard/reports/report-sales",
            roles: ["PanelUser"],
          },
          {
            icon: "mdi-cash-refund",
            text: "Aylık Satış İade Raporları",
            to: "/dashboard/reports/report-sales-refund",
            roles: ["PanelUser"],
          },
          {
            icon: "mdi-wallet-outline",
            text: "Bütçe Raporları",
            to: "/dashboard/reports/report-budget-reports",
            roles: ["PanelUser"],
          },
        ],
      },
      {
        icon: "mdi-chevron-up",
        "icon-alt": "mdi-chevron-down",
        text: "Başvuru Yönetimi",
        model: false,
        roles: ["PanelUser", "AppliedMerchantUser"],
        children: [
          {
            icon: "mdi-text-box",
            text: "Başvuru Listesi",
            to: "/dashboard/apply/merchant/list",
            roles: ["PanelUser"],
          },
          {
            icon: "mdi-text-box",
            text: "Başvuru Bilgileri",
            to: "/dashboard/apply/merchant",
            roles: ["AppliedMerchantUser"],
          },
        ],
      },
    ],
    userMenu: [{ title: "Çıkış yap" }],
    drawer: null,
    nameSurname: "",
  }),
  created() {
    if (localStorage.getItem("userRoles") != null) {
      const accessToken = localStorage.getItem("frinkUserToken");
      const payload = accessToken.split(".")[1];
      const decoder = new TextDecoder("utf-8");
      const tokenDecodeData = JSON.parse(
        decoder.decode(this.base64UrlDecode(payload)),
      );
      this.userRoles = [tokenDecodeData.roleName];
      localStorage.setItem(
        "userRoles",
        JSON.stringify([tokenDecodeData.roleName]),
      );
    }
    if (localStorage.getItem("frinkUserToken") != null) {
      this.nameSurname = localStorage
        .getItem("nameSurname")
        .toLocaleUpperCase();
    }
  },
};
</script>
<style scoped>
.v-application .blue.darken-3 {
  background-color: #4d48f9 !important;
  border-color: #4d48f9 !important;
}

.v-list-item {
  color: #4d48f9 !important;
}
</style>
